export const LOCAL_STORAGE_TYPE = {
  USER_TOKEN: "USER_TOKEN",
  USER_REFRESH_TOKEN: "USER_REFRESH_TOKEN",
  REMEMBER: "REMEMBER",
  USER_FULL_NAME: "USER_FULL_NAME",
  PATH_TO_REDIRECT: "PATH_TO_REDIRECT", // using for redirect to exact url after login (ex: go to product review detail after login if not login befores)
  DATE_ONLY_FORMAT: "DATE_ONLY_FORMAT", //Format date from server DD/MM/YYYY
  DATE_TIME_FORMAT: "DATE_TIME_FORMAT", //Format date from server DD/MM/YYYY HH:mm:ss
  CURRENT_APP_ID: "CURRENT_APP_ID",
  CURRENT_AD_ACCOUNT: "CURRENT_AD_ACCOUNT",
  LANGUAGE: "LANGUAGE",
  PARTNER_CODE: "PARTNER_CODE",
  PRE_PATHNAME: "PRE_PATHNAME",
};

export const setLocalStorage = (type, data) => localStorage.setItem(type, data);

export const delLocalStorage = (type) => localStorage.removeItem(type);

export const getLocalStorage = (type) => localStorage.getItem(type);

export const clearLocalStorage = () => localStorage.clear();
